import { createAction } from '@reduxjs/toolkit';
import { CommonFeatures, AsyncRequestStateActions } from '../types';
import { getActionTypePrefix } from '../../utils';

export const resetAsyncRequestState = createAction<string>(
  getActionTypePrefix(CommonFeatures.APP, AsyncRequestStateActions.RESET),
);
